import { jsxs as p, jsx as r, Fragment as R } from "react/jsx-runtime";
import o from "react";
import { t as T } from "../../bundle-mjs-DoW15_-f.js";
import { Tooltip as e } from "../Tooltip/index.js";
import { cn as h } from "../../utils/cn.js";
import { typographyTheme as j } from "./theme.js";
import { useEllipsis as _ } from "./useEllipsis.js";
import { tooltipContentClassName as F } from "../Tooltip/TooltipContent.js";
const M = o.forwardRef(
  ({
    color: c,
    as: a = "p",
    className: s,
    children: t,
    responsive: y = !0,
    variant: f = "inherit",
    ellipsisTooltip: l,
    tooltip: d,
    ...n
  }, m) => {
    const { targetElementRef: g, measureRef: u, isOverflowing: C } = _(), { styles: E } = j, { colors: b, responsive: v, variants: N, base: w } = E;
    s = c ? s : T(w, s);
    const x = b[c ?? "inherit"], i = h(
      x,
      N[f],
      {
        [v[f]]: y
      },
      s
    );
    return d ? /* @__PURE__ */ p(e, { children: [
      /* @__PURE__ */ r(e.Trigger, { asChild: !0, children: o.createElement(
        a,
        {
          ...n,
          ref: m,
          className: i
        },
        t
      ) }),
      /* @__PURE__ */ r(e.Content, { className: "tooltip-content p-1", children: d })
    ] }) : l ? /* @__PURE__ */ p(e, { disabled: !C, children: [
      /* @__PURE__ */ r(e.Trigger, { asChild: !0, children: o.createElement(
        a,
        {
          ...n,
          ref: g,
          className: h(
            "overflow-hidden text-ellipsis",
            i
          )
        },
        /* @__PURE__ */ p(R, { children: [
          /* @__PURE__ */ r(
            "span",
            {
              style: {
                position: "absolute",
                visibility: "hidden"
              },
              ref: u,
              children: o.createElement(
                "span",
                {
                  ...n,
                  ref: m,
                  className: i
                },
                t
              )
            }
          ),
          t
        ] })
      ) }),
      /* @__PURE__ */ r(e.Content, { className: F, children: typeof l == "boolean" ? t : l })
    ] }) : o.createElement(
      a,
      {
        ...n,
        ref: m,
        className: i
      },
      t
    );
  }
);
M.displayName = "Typography";
export {
  M as Typography,
  M as default
};
